import {
    GET_USER_SUCCESS,
    LOGIN_SUCCESS,
    SOCIAL_LOGIN_SUCCESS,
    LOGOUT_SUCCESS,
    SIGN_UP_SUCCESS,
    // USER_COUNTRY_CODE_SUCCESS,
    UPDATE_USER_SUCCESS,
} from "../actions/UserActions";

const initialState = {};

export default function UserReducer(state = initialState, action) {
    switch (action.type) {
        case LOGIN_SUCCESS:
        case SIGN_UP_SUCCESS:
        case GET_USER_SUCCESS:
        case SOCIAL_LOGIN_SUCCESS:
        // case USER_COUNTRY_CODE_SUCCESS:
        case UPDATE_USER_SUCCESS:
            return {
                ...state,
                ...action.payload
            };

        case LOGOUT_SUCCESS:
            return {...initialState};
    }

    return state;
}